const formReferrer = () => {
  //  this is for the form data tracking
  const refEl = document.getElementById('refInput');
  if (refEl) {
    let referrer;
    $('#refInput').val(document.referrer);
  }
};

export default formReferrer;
